import React from "react";
import { Link } from "react-router-dom";

function ITProjectCard() {
    return (
        <section className="service-section bg-grey padding">
            <div className="map-pattern" />
            <div className="container">
                <div className="row gy-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="service-item wow fade-in-bottom" data-wow-delay="100ms">
                            <div className="service-thumb">
                                <img src="assets/img/project-1.jpg" alt="thumb" />
                            </div>
                            <div className="service-content">
                                <div className="service-icon"></div>
                                <h3><a href="">Jewellery Software</a></h3>
                                <p>TITA TECHNOLOGIES specializes in providing tailored software solutions for the jewellery industry, addressing complex business needs with ease. Leveraging in-depth industry knowledge, the software is designed to align with current jewellery trends, offering comprehensive and customizable features for all jewellery businesses.</p>
                               <Link className="read-more" to="/projectdetails">View More</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="service-item wow fade-in-bottom" data-wow-delay="300ms">
                            <div className="service-thumb">
                                <img src="assets/img/project-2.jpg" alt="thumb" />
                            </div>
                            <div className="service-content">
                                <div className="service-icon"></div>
                                <h3><a href="">Retail Software</a></h3>
                                <p>TITA TECHNOLOGIES is a flexible, user-friendly software tailored for retail businesses, whether standalone or multi-store chains. Designed with an in-depth understanding of retail strategies, it streamlines operations and boosts efficiency, making it the perfect solution for your business needs.</p>
                                <Link className="read-more" to="/projectdetails2">View More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ITProjectCard;